<div class="conflict-dialog">
  <h2 mat-dialog-title>
    <mat-icon color="warn">warning</mat-icon>
    Import Conflicts Detected
  </h2>

  <mat-dialog-content>
    <div class="conflict-summary">
      <p class="conflict-message">{{ data.message }}</p>
      
      <div class="conflict-stats">
        <div class="stat-item">
          <mat-icon>date_range</mat-icon>
          <span><strong>{{ getTotalDates() }}</strong> conflicting dates</span>
        </div>
        <div class="stat-item">
          <mat-icon>storage</mat-icon>
          <span><strong>{{ getTotalConflicts() }}</strong> existing records</span>
        </div>
      </div>
    </div>

    <div class="conflict-details">
      <h3>Conflicting Dates:</h3>
      <div class="conflict-list">
        <div *ngFor="let conflict of data.conflicts" class="conflict-item">
          <div class="conflict-date">
            <mat-icon>calendar_today</mat-icon>
            <strong>{{ conflict.date }}</strong>
            <span class="record-count">({{ conflict.existingRecordCount }} records)</span>
          </div>
          <div class="affected-employees">
            <span class="employee-label">Affected employees:</span>
            <span class="employee-list">{{ conflict.affectedEmployees.join(', ') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="action-explanation">
      <h3>What would you like to do?</h3>
      <div class="option">
        <mat-icon color="primary">refresh</mat-icon>
        <div>
          <strong>Overwrite Existing Data</strong>
          <p>Delete existing records for these dates and import new data</p>
        </div>
      </div>
      <div class="option">
        <mat-icon color="accent">skip_next</mat-icon>
        <div>
          <strong>Skip Conflicting Dates</strong>
          <p>Keep existing records and only import data for non-conflicting dates</p>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      <mat-icon>cancel</mat-icon>
      Cancel Import
    </button>
    <button mat-button (click)="onSkip()" color="accent">
      <mat-icon>skip_next</mat-icon>
      Skip Conflicts
    </button>
    <button mat-raised-button (click)="onOverwrite()" color="warn">
      <mat-icon>refresh</mat-icon>
      Overwrite Data
    </button>
  </mat-dialog-actions>
</div>
